import { t } from "../services/utils";
import React, { Component } from "react";
import { Button } from "@material-ui/core";
import { primaryDark, primaryDark5, primaryDark60 } from "../constants/colors";
class NoRecordFound extends Component {
  render() {
    const {
      img,
      title,
      isLearnMore = false,
      onLearnMoreBtnClick,
      subtitle,
      forModal,
      forStories,
    } = this.props;
    let styles = {
      emptyViewContainer: {
        padding: forModal ? "80px 170px" : "80px 10px 80px 0px",
        backgroundColor: forModal ? primaryDark5 : "transparent",
        // boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.1)",
        borderRadius: forModal ? 0 : 6,
        display: "flex",
        alignItems: "center",
        // justifyContent: "center",
        flexDirection: "column",
        marginTop: forStories ? 20 : 0,
        height: forStories ? 230 : "unset",
      },
      emptyStateIcon: {
        // height: 125,
        height: 50,
        marginTop: 39,
      },
      imageWrapper: {
        border: "1px solid #CCC9D5",
        width: 128,
        height: 128,
        borderRadius: 64,
        textAlign: "center",
      },
      title: {
        marginTop: 30,
        fontSize: 20,
        fontWeight: "600",
        lineHeight: "26px",
        color: primaryDark,
        textAlign: "center",
        alignItems: "center",
      },
      subtitle: {
        marginTop: 2,
        fontSize: 14,
        fontWeight: "500",
        lineHeight: "20px",
        color: primaryDark60,
        textAlign: "center",
      },
      ctaButton: {
        marginTop: 24,
      },
    };
    return (
      <div style={styles.emptyViewContainer}>
        <div style={styles.imageWrapper}>
          <img
            style={styles.emptyStateIcon}
            src={img || require(`../img/no-record-found.png`)}
          />
        </div>
        <div style={styles.title}>{title}</div>
        {subtitle && <div style={styles.subtitle}>{subtitle}</div>}
        {isLearnMore && (
          <Button
            variant="contained"
            color="primary"
            style={styles.ctaButton}
            onClick={onLearnMoreBtnClick}
          >
            {t("learnMore")}
          </Button>
        )}
      </div>
    );
  }
  static getHeight(props) {
    return 400;
  }
}
export default NoRecordFound;
